export default __webpack_public_path__ + "static/media/symbolcypher-02.6f313d38.png";